import { DialogProps } from '@material-ui/core';
import React from 'react';
import { StyledDialog } from './StyledDialog';

interface ProductTourDialogOwnProps {
  onClose?: VoidFunction;
  className?: string;
  dialogContent: React.ComponentType<{ onClose?: VoidFunction }>;
}

export type ProductTourDialogProps = ProductTourDialogOwnProps & DialogProps;

/**
 * Use HOC to bind redux
 */
export function ProductTourDialog(props: ProductTourDialogProps) {
  const { className, onClose, dialogContent: DialogContent, ...rest } = props;

  return (
    <StyledDialog
    {...rest}
    onClose={onClose}
    disableBackdropClick={true}
    className={className}
    >
      <DialogContent onClose={onClose} />
    </StyledDialog>
  );
}
